import { AutocompleteInputChangeReason, Grid, Typography } from "@mui/material";
import { Nullable } from "../../../../../../common/types/nullable";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { WorkLocation as WorkLocationExtended } from "../../../../../../features/customer/types/queries";
import CustomerOrgsAndWorkLocationsAutocomplete from "../../../../../../common/components/functional/autocomplete/customerOrgsAndWorkLocationsAutocomplete/CustomerOrgsAndWorkLocationsAutocomplete";

type Props = {
  options: WorkLocationExtended[];
  onChange: (value: Nullable<WorkLocationExtended>) => void;
  onInputChange: (value: string, reason: AutocompleteInputChangeReason) => void;
  value: Nullable<WorkLocationExtended>;
  isLoading: boolean;
};

const CustomerSection = ({
  options,
  onInputChange,
  onChange,
  value,
  isLoading,
}: Props) => {
  const { t } = useTranslation("talentProfile");

  return (
    <>
      <Grid item xs={12}>
        <Typography>{t("profileSummary.selectCustomer")}</Typography>
      </Grid>
      <Grid item xs={12} mb="8px">
        <CustomerOrgsAndWorkLocationsAutocomplete
          options={options}
          value={value}
          onInputChange={onInputChange}
          onChange={onChange}
          isLoading={isLoading}
          optionLabelWithCustomerOrgName
        />
      </Grid>
    </>
  );
};

export default CustomerSection;
